import styled from 'styled-components';

const H3 = styled.h3`
  font-size: 25px;
  font-family: 'Montserrat';
  font-weight: 600;
  margin-bottom: 0.25em;
  line-height:1.3em;
  margin-top: 0; !important;
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;


  @media (min-width: 992px) {
    font-size: 25px;
  }
`;

export default H3;